const createQuery = () => `
  ... on HtmlWidget {
    html
    designV2
    padding
  }
`
export default createQuery
